import {useExportYearlyRevenueExcel} from "../hooks/useExportYearlyRevenueExcel";
import {SalesSearchParamType, SalesYearlyMapSummaryType, SalesYearlyMapType} from "../interface";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    yearlyRevenue: SalesYearlyMapType
    searchParam: SalesSearchParamType
}

function DataRenderer({data}: { data: SalesYearlyMapSummaryType }) {
    const revenueGoal = Number(data.revenueGoal?.toFixed(2))
    const estimatedRevenue = Number(data.estimatedRevenue?.toFixed(2))
    const actualRevenue = Number(data.actualRevenue?.toFixed(2))
    const estimatedRevenueRate = Number(data.estimatedRevenueRate?.toFixed(2))
    const achievementRevenueRate = Number(data.achievementRevenueRate?.toFixed(2))

    return <>
        <td>{isNaN(revenueGoal) ? "" : <DisplayNumber value={revenueGoal}/>}</td>
        <td>{isNaN(estimatedRevenue) ? "" : <DisplayNumber value={estimatedRevenue}/>}</td>
        <td>{isNaN(actualRevenue) ? "" : <DisplayNumber value={actualRevenue}/>}</td>
        <td>{isNaN(estimatedRevenueRate) ? "" : <DisplayNumber value={estimatedRevenueRate}/>}</td>
        <td>{isNaN(achievementRevenueRate) ? "" : <DisplayNumber value={achievementRevenueRate}/>}</td>
    </>
}

export default function Tab1({yearlyRevenue, searchParam}: PropsType) {
    const {mutate: mutateExportYearlyRevenueExcel} = useExportYearlyRevenueExcel()

    const btnExportExcel = () => {
        mutateExportYearlyRevenueExcel({...searchParam, teamId: searchParam.teamId ?? null})
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">매출 목록</h6>
            {/*<h6 className="table_stats">매출 목록(<span>13</span>건)</h6>*/}
            <div className="table_toolbar">
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt=""/>엑셀 내보내기
                </button>
            </div>
        </div>

        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th>반기</th>
                    <th>분기</th>
                    <th>월</th>
                    <th>담당자</th>
                    <th>경영 목표</th>
                    <th>예상 매출</th>
                    <th>실 매출</th>
                    <th>기대 수익율</th>
                    <th>달성율</th>
                </tr>
                </thead>
                <tbody>
                {(() => {
                    const m1 = yearlyRevenue.firstHalfData.firstQuarterData.firstMonthData.monthSummaryList
                    const m2 = yearlyRevenue.firstHalfData.firstQuarterData.secondMonthData.monthSummaryList
                    const m3 = yearlyRevenue.firstHalfData.firstQuarterData.thirdMonthData.monthSummaryList
                    const q1 = yearlyRevenue.firstHalfData.firstQuarterData.quarterSummary
                    const m4 = yearlyRevenue.firstHalfData.secondQuarterData.firstMonthData.monthSummaryList
                    const m5 = yearlyRevenue.firstHalfData.secondQuarterData.secondMonthData.monthSummaryList
                    const m6 = yearlyRevenue.firstHalfData.secondQuarterData.thirdMonthData.monthSummaryList
                    const q2 = yearlyRevenue.firstHalfData.secondQuarterData.quarterSummary
                    const h1 = yearlyRevenue.firstHalfData.halfSummary

                    const m7 = yearlyRevenue.secondHalfData.firstQuarterData.firstMonthData.monthSummaryList
                    const m8 = yearlyRevenue.secondHalfData.firstQuarterData.secondMonthData.monthSummaryList
                    const m9 = yearlyRevenue.secondHalfData.firstQuarterData.thirdMonthData.monthSummaryList
                    const q3 = yearlyRevenue.secondHalfData.firstQuarterData.quarterSummary
                    const m10 = yearlyRevenue.secondHalfData.secondQuarterData.firstMonthData.monthSummaryList
                    const m11 = yearlyRevenue.secondHalfData.secondQuarterData.secondMonthData.monthSummaryList
                    const m12 = yearlyRevenue.secondHalfData.secondQuarterData.thirdMonthData.monthSummaryList
                    const q4 = yearlyRevenue.secondHalfData.secondQuarterData.quarterSummary
                    const h2 = yearlyRevenue.secondHalfData.halfSummary

                    const y = yearlyRevenue.yearlySummary

                    return <>
                        {/* 상반기 */}
                        {m1.map((el, idx) => <tr>
                            {idx === 0 && <>
                                <td className="text-center"
                                    rowSpan={m1.length + m2.length + m3.length + m4.length + m5.length + m6.length + 3}>상반기
                                </td>
                                <td className="text-center" rowSpan={m1.length + m2.length + m3.length + 1}>1분기</td>
                                <td rowSpan={m1.length}>1월</td>
                            </>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m2.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m2.length}>2월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m3.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m3.length}>3월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        <tr>
                            <td className="text-center" colSpan={2}>{q1.summaryType}</td>
                            <DataRenderer data={q1}/>
                        </tr>
                        {m4.map((el, idx) => <tr>
                            {idx === 0 && <>
                                <td className="text-center" rowSpan={m4.length + m5.length + m6.length + 1}>2분기</td>
                                <td rowSpan={m4.length}>4월</td>
                            </>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m5.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m5.length}>5월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m6.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m6.length}>6월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        <tr>
                            <td className="text-center" colSpan={2}>{q2.summaryType}</td>
                            <DataRenderer data={q2}/>
                        </tr>
                        <tr>
                            <td className="text-center" colSpan={3}>{h1.summaryType}</td>
                            <DataRenderer data={h1}/>
                        </tr>

                        {/* 하반기 */}
                        {m7.map((el, idx) => <tr>
                            {idx === 0 && <>
                                <td className="text-center"
                                    rowSpan={m7.length + m8.length + m9.length + m10.length + m11.length + m12.length + 3}>하반기
                                </td>
                                <td className="text-center" rowSpan={m7.length + m8.length + m9.length + 1}>3분기</td>
                                <td rowSpan={m7.length}>7월</td>
                            </>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m8.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m8.length}>8월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m9.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m9.length}>9월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        <tr>
                            <td className="text-center" colSpan={2}>{q3.summaryType}</td>
                            <DataRenderer data={q3}/>
                        </tr>
                        {m10.map((el, idx) => <tr>
                            {idx === 0 && <>
                                <td className="text-center" rowSpan={m10.length + m11.length + m12.length + 1}>4분기</td>
                                <td rowSpan={m10.length}>10월</td>
                            </>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m11.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m11.length}>11월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        {m12.map((el, idx) => <tr>
                            {idx === 0 && <td rowSpan={m12.length}>12월</td>}
                            <td>{el.summaryType}</td>
                            <DataRenderer data={el}/>
                        </tr>)}
                        <tr>
                            <td className="text-center" colSpan={2}>{q4.summaryType}</td>
                            <DataRenderer data={q4}/>
                        </tr>
                        <tr>
                            <td className="text-center" colSpan={3}>{h2.summaryType}</td>
                            <DataRenderer data={h2}/>
                        </tr>

                        {/* 연간 총합 */}
                        <tr>
                            <td className="text-center" colSpan={4}>{y.summaryType}</td>
                            <DataRenderer data={y}/>
                        </tr>
                    </>
                })()}
                </tbody>
            </table>
        </div>
    </div>
}